module.exports = __webpack_public_path__ + "static/img/12.ec1255a.png";


//////////////////
// WEBPACK FOOTER
// ./static/images/products/2/1/2/sp/12.png
// module id = /KuX
// module chunks = 0